import { Request, Response } from 'api/typegen/client/application/post';
import { useErrorManager } from 'InternalLibrary/app';
import { useLexisNexis } from 'hooks/useLexisNexis';
import { useMutation } from '@tanstack/react-query';
import { usePostClientApplication } from 'api/atoms';
import useSmartlook from 'hooks/useSmartlook';

function useApplicationAndLexisNexisMutation() {
  const { error } = useSmartlook();
  const { setError } = useErrorManager();
  const { isLexisNexisAvailable, triggerLexisNexisProfiling } = useLexisNexis();
  const { fetch: fetchPostApplication } = usePostClientApplication();
  return useMutation<Response, unknown, Request>({
    mutationFn: async (payload: Request) => {
      if (isLexisNexisAvailable) await triggerLexisNexisProfiling(); // data-collector for LexisNexis (only for vivus)
      try {
        return await fetchPostApplication({
          body: payload,
        });
      } catch (e) {
        error('[useApplicationMutation][POST /client/application]', e);
        setError();
        throw e;
      }
    },
  });
}

// Sort out the options
export type UseClientEmployerMutationOptions = {
  level: string;
};

export default useApplicationAndLexisNexisMutation;
